/* eslint-disable eqeqeq */
/* eslint-disable no-shadow */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import "emoji-mart/css/emoji-mart.css";
import "react-markdown-editor-lite/lib/index.css";

import {
  CheckSquareTwoTone,
  DownOutlined,
  LinkOutlined,
  SearchOutlined,
  SmileTwoTone,
  UserAddOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  Col,
  DatePicker,
  Dropdown,
  Input,
  Menu,
  message as antmessage,
  Modal,
  Popover,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tabs,
  Tooltip,
} from "antd";
import dayjs from "dayjs";
import { Picker } from "emoji-mart";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Emoji from "react-emoji-render";
import Highlighter from "react-highlight-words";
import { useDispatch, useSelector } from "react-redux";

import { getUsersPaginated } from "../../lib/queries";
import { getSupaClient } from "../../lib/supabase";
import {
  setMessagesNoReplyData,
  setReplyModalStatus,
} from "../../redux/actions";
import { lambdaPost } from "../../utils/general";
import { SlackEditor } from "../TextEditor/SlackEditor";
import Templates from "../Templates/Templates";
import TweetView from "../TweetView/TweetView";

const { TabPane } = Tabs;
// import style manually

const { Option } = Select;

const { RangePicker } = DatePicker;

const defaultTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";
const dateFormat = "YYYY-MM-DD";

const neverMatchingRegex = /($a)/;

function timeSince(ts) {
  const date = new Date(parseFloat(ts) * 1000);
  const seconds = Math.floor((new Date() - date) / 1000);

  let interval = seconds / 31536000;

  if (interval > 1) {
    return { text: `${Math.floor(interval)} years`, seconds };
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return { text: `${Math.floor(interval)} months`, seconds };
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return { text: `${Math.floor(interval)} days`, seconds };
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return { text: `${Math.floor(interval)} hours`, seconds };
  }
  interval = seconds / 60;
  if (interval > 1) {
    return { text: `${Math.floor(interval)} mins`, seconds };
  }
  return { text: `${Math.floor(seconds)} secs`, seconds };
}

const style = {
  suggestions: {
    list: {
      maxHeight: 200,
      overflow: "auto",
      minWidth: 200,
      marginTop: 20,
      border: "0.2px solid #dfe1e6",
      borderRadius: 5,
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    },
  },
  borderRadius: "5px",
  width: "100%",
  minHeight: "100px",
  border: "1px solid #a6a8ad",
  margin: 5,
};

// params: props filter object
const MessagesNoReply = (props) => {
  const supabase = getSupaClient();
  const [loading, setLoading] = useState(true);
  const [isSending, setIsSending] = useState(false);
  const [selectedReplyMessage, setSelectedReplyMessage] = useState({});
  const [startTime, setStartTime] = useState(
    moment().subtract(7, "d").format(dateFormat)
  );
  const [endTime, setEndTime] = useState(moment().format(dateFormat));
  const [messagesNoReplies, setMessagesNoReplies] = useState([]);
  const [datePickerText, setDatePickerText] = useState("Past 7 days");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isReplyModalVisible, setIsReplyModalVisible] = useState(false);
  const [showMarkCompleteAll, setShowMarkCompleteAll] = useState(false);
  const [selectedMessages, setSelectedMessages] = useState([]);
  const [excludeChannels, setExcludeChannels] = useState([]);
  const [userSettings, setUserSettings] = useState({
    fav_emoji: ["heavy_plus_sign", "+1", "smile", "sparkles"],
  });
  const [teammates, setTeammates] = useState([]);
  const [selectedTeammate, setSelectedTeammate] = useState("");
  const [usersList, setUsersList] = useState([]);
  const [usersName, setUsersName] = useState([]);
  const [emojis, setEmojis] = useState([]);
  const [messagesFilteredReplies, setMessagesFilteredReplies] = useState([]);

  const [message, setMessage] = useState("");
  const [html, setHtml] = useState("");
  const [templateText, setTemplateText] = useState("");

  const dispatch = useDispatch();

  const teamId = localStorage.getItem("team-id");
  const slackId = localStorage.getItem("slack-id");

  let pendingMessages = useSelector((state) => state.messages.messagesNoReply);

  window.moment = moment;

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  };

  const mapResults = async (results) => {
    results = await results.flatMap((result) => {
      result.key = result.slack_id;
      result.channelName = result.channel_obj
        ? `#${result.channel_obj.name}`
        : "";
      result.user = result.slack_user_obj ? result.slack_user_obj.name : "";
      result.image = result.slack_user_obj
        ? result.slack_user_obj.image_32
        : "";
      const timeSincePosted = timeSince(result.ts);
      result.ageText = timeSincePosted.text;
      result.ageSeconds = timeSincePosted.seconds;
      result.userAdmin = result.slack_user_obj
        ? result.slack_user_obj.is_admin
        : "";
      return result;
    });
    results = results.filter((result) => !result.userAdmin);
    return results;
  };

  const loadNoReplies = async (startTime, endTime, excludeChannelsTemp) => {
    const endDate = dayjs(endTime).add(1, "day").format(dateFormat);
    const base = supabase
      .from("parent_msgs")
      .select(
        `
        slack_id,
        text,
        ts,
        formatted_ts,
        slack_user,
        slack_user_obj:slack_user (name, is_admin, image_32),
        channel,
        channel_obj: channel (name),
        permalink,
        assigned_to,
        to_reply_status,
        reply_count
        `
      )
      .filter("team", "eq", teamId)
      .filter("is_bot", "neq", true);
    if (excludeChannelsTemp) {
      excludeChannelsTemp.forEach((item) => {
        base.filter("channel", "neq", item);
      });
    }
    base
      .gte("formatted_ts", startTime)
      .lte("formatted_ts", endDate)
      .order("ts", { ascending: false });

    const response = await base;
    if (response.error) {
      console.error(base.error);
      window.analytics.track("Error loading messages");
    }
    if (response.data) {
      const displayResults = await mapResults(response.data);
      dispatch(setMessagesNoReplyData(displayResults));

      // TODO: add a filter prop to customize this, but for now doing it for team id hardcoded
      if (teamId === "T47H7EWH0") {
        const filteredResults = displayResults.filter((result) => {
          // hard code for cloud questions
          if (
            result.text.includes("?") &&
            result.text.includes("cloud") &&
            result.text.length > 40
          ) {
            return true;
          }
          return false;
        });
        // console.log("filtered", filteredResults.length, displayResults.length);
        setMessagesFilteredReplies(filteredResults);
      }

      setLoading(false);
    }
    return response;
  };

  const loadPageData = async (startTime, endTime) => {
    await loadNoReplies(startTime, endTime);
    setLoading(false);
  };

  const loadExcludedChannels = async () => {
    const excludeChannel = await supabase
      .from("teams")
      .select("settings_exclude_channels")
      .match({ slack_id: teamId });

    if (
      excludeChannel.data &&
      excludeChannel.data[0] &&
      excludeChannel.data[0].settings_exclude_channels
    ) {
      setExcludeChannels(excludeChannel.data[0].settings_exclude_channels);
      await loadNoReplies(
        startTime,
        endTime,
        excludeChannel.data[0].settings_exclude_channels
      );
    } else {
      await loadNoReplies(startTime, endTime, []);
    }
  };

  const loadUserSettings = async () => {
    // console.log("team id", teamId, slackId);
    // console.log("loading user emojis");
    const { data, error } = await supabase
      .from("users")
      .select("settings")
      .match({ slack_id: slackId });

    if (error) {
      // console.log("Error", error);
      window.analytics.track("User settings load error");
    }
    if (data && data[0] && data[0].settings) {
      // console.log("data", data[0]);
      setUserSettings(data[0].settings);
    }
  };

  const loadTeammates = async () => {
    const { data, error } = await supabase
      .from("users")
      .select("name, slack_id")
      .filter("team", "eq", teamId);

    if (error) {
      console.log("Error loading teammates", error);
      window.analytics.track("Teammates load error");
    }
    if (data && data[0]) {
      setTeammates(data);
    }
  };

  /**
   * Returns the avatar of the teammate to whom a message was assigned
   * @param {*} teammateId The teammate ID
   * @returns the avatar of the teammate that the message was assigned to
   */
  const getTeammateAvatar = (teammateId) => {
    const user = usersList.find((item) => item.slack_id === teammateId);
    if (user.image_32) return user.image_32;
    return "/avatar_slack.png";
  };

  /**
   * Returns the name of the teammate to whom a message was assigned
   * @param {*} teammateId The teammate ID
   * @returns Returns the name of the teammate to whom a message was assigned or an empty string
   */
  const getTeammateName = (teammateId) => {
    const user = usersList.find((item) => item.slack_id === teammateId);
    return user.name;
  };

  /**
   * Updates the status of an assigned message in the pending messages array. This happens
   * after the user assigns a message to a teammate.
   * @param {*} messageId The id of the message to be updated
   * @param {*} teammateId The teammate ID to whom the message was assigned
   */
  const updateAssignedMessage = (messageId, teammateId) => {
    const message = pendingMessages.find((item) => item.slack_id === messageId);
    message.to_reply_status = "assigned";
    message.assigned_to = teammateId;
    pendingMessages = pendingMessages.filter(
      (item) => item.slack_id !== messageId
    );
    pendingMessages.push(message);
  };

  /**
   * Updated the status of a resolved message in he pending messages array. This happens
   * after the user marks a message as "resolved"
   * @param {*} messageId - teh id of he message to be updated
   */
  const updateResolvedMessage = (messageId) => {
    const message = pendingMessages.find((item) => item.slack_id === messageId);
    message.to_reply_status = "done";
    pendingMessages = pendingMessages.filter(
      (item) => item.slack_id !== messageId
    );
    // updatedMessages.push(message);
    // dispatch(setMessagesNoReplyData(pendingMessages));
    pendingMessages.push(message);
  };

  // loadUsersList: This function is being used to fetch users list for message replies.

  const loadUsersList = async () => {
    const response = await getUsersPaginated(teamId);
    const usersNameArray = response.map((item) => {
      const obj = {
        display: item.name,
        id: item.slack_id,
        image: item.image_32,
      };
      return obj;
    });
    setUsersList(response);
    setUsersName(usersNameArray);
  };

  useEffect(() => {
    loadExcludedChannels();
    loadUserSettings();
    loadTeammates();
    loadUsersList();
    fetch(
      "https://gist.githubusercontent.com/oliveratgithub/0bf11a9aff0d6da7b46f1490f86a71eb/raw/d8e4b78cfe66862cf3809443c1dba017f37b61db/emojis.json"
    )
      .then((response) => {
        return response.json();
      })
      .then((jsonData) => {
        setEmojis(jsonData.emojis);
      });
    // document.title = "Messages without replies | Dots";
  }, []);

  const changeDates = async (startTime, endTime) => {
    setLoading(true);
    setStartTime(moment(startTime).format(dateFormat));
    setEndTime(moment(endTime).format(dateFormat));
    loadPageData(startTime, endTime);
    setLoading(false);
  };

  function handleMenuClick(e) {
    // console.log('click', e);
    if (e.key == 1) {
      antmessage.info("Loading..");
      changeDates(
        moment().subtract(1, "day").format(defaultTimeFormat),
        moment().format(defaultTimeFormat)
      );
      setDatePickerText("Past 24 hours");
    }
    // past 7 days
    else if (e.key == 2) {
      antmessage.info("Loading..");
      changeDates(
        moment().subtract(7, "day").format(defaultTimeFormat),
        moment().format(defaultTimeFormat)
      );
      setDatePickerText("Past 7 days");
    }
    // past 30 days
    else if (e.key == 3) {
      antmessage.info("Loading..");
      changeDates(
        moment().subtract(30, "day").format(defaultTimeFormat),
        moment().format(defaultTimeFormat)
      );
      setDatePickerText("Past 30 days");
    }
    // custom
    else if (e.key == 4) {
      // console.log("custom", startTime, moment(startTime, dateFormat));
      setDatePickerText("Select range");
    }
  }
  // data changed

  const showModal = () => {
    setIsModalVisible(true);
  };

  const showReplyModal = (record) => {
    setSelectedReplyMessage(record);
    setIsReplyModalVisible(true);
    dispatch(setReplyModalStatus(false));
  };

  const removeMessage = async (messages) => {
    const removedArray = await pendingMessages.filter(function (obj) {
      // console.log("in filter", obj.slack_id!=message.slack_id)
      return !messages.includes(obj);
    });
    // console.log("message removed", message, removedArray.length, removedArray);
    dispatch(setMessagesNoReplyData(removedArray));
  };

  /**
   * Update all messages in the database to set to_reply_status to "done"
   * @param {*} messages
   * @returns
   */
  const markDone = async (messages) => {
    const messageIds = messages.map((item) => item.slack_id);
    const { data, error } = await supabase
      .from("parent_msgs")
      .update({ to_reply_status: "done" })
      .in("slack_id", messageIds);

    if (error) {
      antmessage.error("Action failed.");
      window.analytics.track("Mark reviewed error.");
      return;
    }
    antmessage.info("Action complete!");
    window.analytics.track("Mark reviewed");
    // await removeMessage(messages);
  };

  const handleResolvedMessage = async (record) => {
    setIsSending(true);
    await markDone([record]);
    updateResolvedMessage(record.slack_id);
    setIsSending(false);
  };

  const cancelReplyModal = () => {
    setIsReplyModalVisible(false);
    setMessage("");
    setHtml("");
    setTemplateText("");
    setSelectedReplyMessage({});
    dispatch(setReplyModalStatus(true));
  };

  // formatMessages: This function is being used to format message according to backend requirements.

  const formatMessages = () => {
    let formattedMessage = message;

    usersList.map((item) => {
      formattedMessage = formattedMessage.replace(`@[${item.name}]`, "");

      return formattedMessage;
    });

    return formattedMessage;
  };

  const sendReply = async () => {
    const formattedMessage = formatMessages();
    setIsSending(true);
    const res = await lambdaPost(
      {
        channel: selectedReplyMessage.channel,
        thread_ts: selectedReplyMessage.ts,
        message: formattedMessage,
      },
      "postreply"
    );
    await markDone([selectedReplyMessage]);
    window.analytics.track("Sending reply from No replies");
    cancelReplyModal();
    setIsSending(false);
  };

  const handleCancel = () => {
    setDatePickerText(
      `${moment(startTime).format(dateFormat)} - ${moment(endTime).format(
        dateFormat
      )}`
    );
    setIsModalVisible(false);
  };

  const dateChanged = async (date, dateString) => {
    setLoading(true);
    // console.log(
    //   date,
    //   dateString,
    //   date[0].format(defaultTimeFormat),
    //   moment().format(defaultTimeFormat),
    //   moment().subtract(7, "day").format(defaultTimeFormat)
    // );
    setStartTime(date[0]);
    setEndTime(date[1]);
    await loadPageData(
      date[0].format(defaultTimeFormat),
      date[1].format(defaultTimeFormat)
    );
    window.analytics.track("Date changed in messages");
    setDatePickerText(
      `${moment(startTime).format(dateFormat)} - ${moment(endTime).format(
        dateFormat
      )}`
    );
    setLoading(false);
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="1">Past 24 hours</Menu.Item>
      <Menu.Item key="2">Past 7 days</Menu.Item>
      <Menu.Item key="3">Past 30 days</Menu.Item>
      <Menu.Item key="4" onClick={showModal}>
        Custom
      </Menu.Item>
    </Menu>
  );

  const getChannelFilters = (posts) => {
    const filterValues = new Set();
    for (const post of posts) {
      filterValues.add(post.channelName);
    }
    const filters = [];
    for (const value of filterValues) {
      filters.push({ text: value, value });
    }
    return filters;
  };

  const onTemplateInsert = (templateText) => {
    setTemplateText(templateText);
    // setMessage(message + templateText);
  };

  const addEmoji = (e) => {
    const emoji = e.native;
    setMessage(message + emoji);
  };

  const reactWithEmoji = async (record, emoji) => {
    // setMessage(emoji)
    // setSelectedReplyMessage(record)
    // console.log(message, selectedReplyMessage)
    setIsSending(true);
    const res = await lambdaPost(
      {
        channel: record.channel,
        thread_ts: record.ts,
        emoji,
        reaction: true,
      },
      "postreply"
    );
    await markDone([record]);
    window.analytics.track("Reacted with emoji");
    setIsSending(false);
  };

  const assignMessage = async (record, teammateId) => {
    setIsSending(true);
    const { data, error } = await supabase
      .from("parent_msgs")
      .update({ assigned_to: teammateId, to_reply_status: "assigned" })
      .match({ slack_id: record.slack_id });
    const res = await lambdaPost(
      {
        assigned_to: teammateId,
        permalink: record.permalink,
        team: teamId,
      },
      "assignmessage"
    );
    updateAssignedMessage(record.slack_id, teammateId);
    // await markDone([record]);
    // await removeMessage([record]);
    window.analytics.track("Assigned to teammate");
    setIsSending(false);
    antmessage.success("Successfully assigned!");
  };

  const emojiContent = (record) => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
            marginBottom: 10,
          }}
        >
          <Tooltip title="Click this will react the message with the emoji!">
            <Space>
              {userSettings.fav_emoji.map((item) => (
                <Button key={item} onClick={() => reactWithEmoji(record, item)}>
                  <Emoji text={`:${item}:`} />
                </Button>
              ))}
            </Space>
          </Tooltip>
        </div>
        <p>Edit these emojis under settings</p>
        {isSending ? (
          <div>
            <Spin />
            Sending...
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  const assignContent = (record) => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
            marginBottom: 10,
          }}
        >
          <Space>
            <Select
              style={{ width: 200, marginLeft: 10 }}
              placeholder="Select a teammate"
              onSelect={setSelectedTeammate}
            >
              {teammates.map(function (teammate) {
                return (
                  <Option
                    key={teammate.slack_id}
                    value={teammate.slack_id}
                    name={teammate.name}
                  >
                    {teammate.name}
                  </Option>
                );
              })}
            </Select>
            <Button
              type="primary"
              onClick={() => assignMessage(record, selectedTeammate)}
            >
              Assign
            </Button>
          </Space>
        </div>
        {isSending ? (
          <div>
            <Spin />
            Assigning...
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  const emojiTooltip = (
    <div>
      <Picker onSelect={addEmoji} showPreview={false} title="Pick an emoji" />
    </div>
  );

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // markDone(selectedRows[0])
      // console.log(selectedRowKeys, selectedRows)
      setSelectedMessages(selectedRows);
      if (selectedRowKeys.length == 0) {
        setShowMarkCompleteAll(false);
      } else {
        setShowMarkCompleteAll(true);
      }
    },
  };

  const markAllSelectedDone = async () => {
    // console.log(selectedMessages)
    window.analytics.track("Mark selected message reviewed");
    await markDone(selectedMessages);
    setShowMarkCompleteAll(false);
  };

  const markEverythingDone = async () => {
    window.analytics.track("Mark every message reviewed");
    await markDone(pendingMessages);
    setShowMarkCompleteAll(false);
  };

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getMessageSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            // eslint-disable-next-line no-unused-vars
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
          }}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{ fontSize: 20, color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) => {
      return record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "";
    },
    onFilterDropdownVisibleChange: () => {},
    render: (text, record) => {
      return (
        <div>
          <Row>
            <Col span={2}>
              <Avatar src={record.image} />
            </Col>
            <Col span={22}>
              <Row>
                <span style={{ color: "grey", marginRight: "10px" }}>
                  {record.user}
                </span>
                <Tooltip title="Click to open in slack">
                  <a href={record.permalink} target="_blank" rel="noreferrer">
                    <img
                      alt="Link"
                      width="16"
                      className="pt-0.5"
                      src="/external-link.svg"
                    />
                  </a>
                </Tooltip>
              </Row>
              <Row>
                <a onClick={() => showReplyModal(record)}>
                  {searchedColumn === dataIndex ? (
                    <Highlighter
                      highlightStyle={{
                        backgroundColor: "#ffc069",
                        padding: 0,
                      }}
                      searchWords={[searchText]}
                      autoEscape
                      textToHighlight={text ? text.toString() : ""}
                    />
                  ) : (
                    <Emoji text={record.text} />
                  )}
                </a>
              </Row>
            </Col>
          </Row>
        </div>
      );
    },
  });

  const columns = [
    {
      title: "Posted",
      dataIndex: "ageText",
      sorter: (a, b) => {
        return a.ageSeconds - b.ageSeconds;
      },
      width: "10%",
    },
    {
      title: "Message",
      dataIndex: "text",
      key: "text",
      onFilter: (value, record) =>
        value === "noreply" ? record.reply_count === 0 : record,
      render: (text, record) => (
        <div>
          <Row>
            <Col span={2}>
              <Avatar src={record.image} />
            </Col>
            <Col span={22}>
              <Row>
                <span style={{ color: "grey", marginRight: "10px" }}>
                  {record.uasdser} hi
                </span>
                <Tooltip title="Click to open in slack">
                  <a href={record.permalink} target="_blank" rel="noreferrer">
                    {/* <img
                      alt="Link"
                      width="12"
                      src="/external-link-alt-solid.svg"
                    /> */}
                    <LinkOutlined
                      className="message_actions"
                      style={{ fontSize: 12, color: "#6C6C6C" }}
                    />
                  </a>
                </Tooltip>
              </Row>
              <Row>
                <a onClick={() => showReplyModal(record)}>
                  <Emoji text={record.text} />
                </a>
              </Row>
            </Col>
          </Row>
        </div>
      ),
      ...getMessageSearchProps("text"),
      width: "60%",
    },
    {
      title: "Channel",
      dataIndex: "channelName",
      filters: getChannelFilters(pendingMessages),
      onFilter: (value, record) => record.channelName.indexOf(value) === 0,
      sorter: (a, b) => {
        if (a.channelName < b.channelName) {
          return -1;
        }
        if (a.channelName > b.channelName) {
          return 1;
        }
        return 0;
      },
      sortDirections: ["descend", "ascend"],
      width: "15%",
    },
    {
      title: "Actions",
      filters: [
        {
          text: "Messages with no replies",
          value: "noreply",
        },
        {
          text: "All messages",
          value: "all",
        },
        {
          text: "Unassigned messages",
          value: "unassigned",
        },
        {
          text: "Assigned messages",
          value: "assigned",
        },
        {
          text: "Unresolved messages",
          value: "unresolved",
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => {
        if (value === "noreply") {
          return record.reply_count === 0 && record.to_reply_status === null;
        }
        if (value === "all") {
          return record;
        }
        if (value === "unassigned") {
          return record.to_reply_status !== "assigned";
        }
        if (value === "assigned") {
          return record.to_reply_status === "assigned";
        }
        if (value === "unresolved") {
          return record.to_reply_status !== "done";
        }
        return record;
      },
      defaultFilteredValue: ["noreply"],
      render: (text, record) => (
        <Space size="middle">
          <div
            style={{
              display: "flex",
              paddingLeft: 10,
              paddingRight: 10,
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                marginBottom: 10,
              }}
            >
              <Space>
                {record.assigned_to ? (
                  <div>
                    <Tooltip
                      placement="left"
                      title={`Assigned to ${getTeammateName(
                        record.assigned_to
                      )}`}
                    >
                      <Avatar
                        src={getTeammateAvatar(record.assigned_to)}
                        className="message_actions"
                      />
                    </Tooltip>
                  </div>
                ) : null}
                {/* <Tooltip title="Click to respond with your fav emoji"> */}
                {record.assigned_to === null ? (
                  <Tooltip placement="left" title="Assign message to teammate">
                    <Popover
                      content={assignContent(record)}
                      title="Assign to a teammate"
                      trigger="click"
                    >
                      <UserAddOutlined
                        className="message_actions"
                        style={{ fontSize: 24, color: "#6C6C6C" }}
                      />
                    </Popover>
                  </Tooltip>
                ) : null}
                {record.to_reply_status !== "done" ? (
                  <Tooltip title="Mark as done if responded or doesn't require a response">
                    <CheckSquareTwoTone
                      className="message_actions"
                      twoToneColor="#52c41a"
                      style={{ fontSize: 24, color: "#6C6C6C" }}
                      onClick={() => handleResolvedMessage(record)}
                    />
                  </Tooltip>
                ) : null}
                {record.to_reply_status === "done" ? (
                  <Tooltip title="This message has been resolved.">
                    <CheckSquareTwoTone
                      className="message_actions"
                      twoToneColor="#9ca3af"
                      style={{ fontSize: 24, color: "#4b5563" }}
                    />
                  </Tooltip>
                ) : null}
              </Space>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                marginBottom: 10,
              }}
            >
              <Space>
                <Tooltip title="Click to reply directly">
                  <a onClick={() => showReplyModal(record)}>
                    <img
                      alt="respond"
                      className="respond-svg message_actions"
                      src="/respond.svg"
                      width="25"
                    />
                  </a>
                </Tooltip>
                <Popover
                  content={emojiContent(record)}
                  title="Click to react with your fav emoji"
                >
                  <SmileTwoTone
                    className="message_actions"
                    style={{ fontSize: 24, color: "#6C6C6C" }}
                  />
                </Popover>
              </Space>
            </div>
          </div>
        </Space>
      ),
      width: "10%",
    },
  ];

  // filterUsersList: This function is being used to filter users list for mentionsInput.

  const filterUsersList = (query) => {
    const queryLower = query.toLowerCase();
    if (query) {
      const filteredArray = usersName.filter((user) =>
        user.display.toLowerCase().startsWith(queryLower)
      );

      return filteredArray.slice(0, 10);
    }
    return [
      {
        id: "1",
        display: "Type a letter to tag",
      },
    ];
  };

  const queryEmojis = (query, callback) => {
    if (query.length === 0) return;

    const matches = emojis
      .filter((emoji) => {
        return emoji.name.indexOf(query.toLowerCase()) > -1;
      })
      .slice(0, 10);
    // eslint-disable-next-line consistent-return
    return matches.map(({ emoji }) => ({ id: emoji }));
  };

  return (
    <div>
      <Spin spinning={loading}>
        <Row justify="spaced-around">
          <Col lg={24} md={24}>
            <Tabs
              style={{ padding: 0 }}
              tabBarExtraContent={
                <Space>
                  <Dropdown overlay={menu}>
                    <Button>
                      {datePickerText} <DownOutlined />
                    </Button>
                  </Dropdown>
                  <Modal
                    width={400}
                    title="Select date range "
                    style={{ top: 40, right: 10 }}
                    visible={isModalVisible}
                    onCancel={handleCancel}
                    footer={[
                      <Button
                        key="submit"
                        type="primary"
                        onClick={handleCancel}
                      >
                        Ok
                      </Button>,
                    ]}
                  >
                    <RangePicker
                      defaultValue={[
                        moment(startTime, dateFormat),
                        moment(endTime, dateFormat),
                      ]}
                      format={dateFormat}
                      disabledDate={disabledDate}
                      onChange={dateChanged}
                    />
                  </Modal>
                </Space>
              }
            >
              <TabPane tab="Slack" key="1">
                <Card
                  bordered={false}
                  extra={
                    showMarkCompleteAll ? (
                      <Space>
                        <Tooltip title="Click to mark everything complete. Make sure you really want to do this!">
                          <Button
                            type="warning"
                            size="small"
                            onClick={() => markEverythingDone()}
                          >
                            <Emoji text=":warning: Mark everything reviewed" />
                          </Button>
                        </Tooltip>
                        <Tooltip title="Click to mark all selected complete">
                          <Button
                            type="primary"
                            size="small"
                            onClick={() => markAllSelectedDone()}
                          >
                            ✨ Mark all selected reviewed
                          </Button>
                        </Tooltip>
                      </Space>
                    ) : (
                      ""
                    )
                  }
                >
                  <div style={{ width: "100%", height: "100%" }}>
                    <Table
                      size="small"
                      dataSource={pendingMessages}
                      columns={columns}
                      rowSelection={{ type: "checkbox", ...rowSelection }}
                    />
                  </div>
                </Card>
              </TabPane>
              <TabPane tab="Twitter (beta)" key="2">
                <TweetView startTime={startTime} endTime={endTime} />
              </TabPane>
              {messagesFilteredReplies.length > 0 ? (
                <TabPane
                  tab={`Cloud questions (${messagesFilteredReplies.length})`}
                  key="3"
                >
                  <Card
                    bordered={false}
                    extra={
                      showMarkCompleteAll ? (
                        <Space>
                          <Tooltip title="Click to mark everything complete. Make sure you really want to do this!">
                            <Button
                              type="warning"
                              size="small"
                              onClick={() => markEverythingDone()}
                            >
                              <Emoji text=":warning: Mark everything reviewed" />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Click to mark all selected complete">
                            <Button
                              type="primary"
                              size="small"
                              onClick={() => markAllSelectedDone()}
                            >
                              ✨ Mark all selected reviewed
                            </Button>
                          </Tooltip>
                        </Space>
                      ) : (
                        ""
                      )
                    }
                  >
                    <div style={{ width: "100%", height: "100%" }}>
                      <Table
                        size="small"
                        dataSource={messagesFilteredReplies}
                        columns={columns}
                        rowSelection={{ type: "checkbox", ...rowSelection }}
                      />
                    </div>
                  </Card>
                </TabPane>
              ) : null}
            </Tabs>
          </Col>
        </Row>

        <Modal
          width={700}
          title="Reply to the message directly"
          style={{ top: 40, right: 10 }}
          visible={isReplyModalVisible}
          onCancel={cancelReplyModal}
          footer={[
            <Button
              key="submit"
              onClick={sendReply}
              disabled={message.length === 0}
              type="primary"
              loading={isSending}
            >
              Send
            </Button>,
          ]}
        >
          <p>
            <strong>
              Reply to {selectedReplyMessage.user}&apos;s message:{" "}
            </strong>{" "}
            <Emoji text={selectedReplyMessage.text} />
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 10,
            }}
          >
            <div className="mr-4 text-gray-500 pt-1">Use @ to tag members!</div>
            <div>
              <Templates newText={html} onInsert={onTemplateInsert} />
            </div>
          </div>
          <Row justify="spaced-around">
            <SlackEditor
              height="150px"
              hidePreview
              value={{ html }}
              templateText={templateText}
              isReplyModalVisible={isReplyModalVisible}
              onChange={(value) => {
                setHtml(value.html);
                setMessage(value.slack_mrkdwn);
                setTemplateText("");
              }}
              disablePersonalTokens
            />
          </Row>
          <Row justify="spaced-around" />
        </Modal>
      </Spin>
    </div>
  );
};

export default MessagesNoReply;
